import { render, staticRenderFns } from "./PhysicalActivityPrint.vue?vue&type=template&id=6aefc285&"
import script from "./PhysicalActivityPrint.vue?vue&type=script&lang=js&"
export * from "./PhysicalActivityPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports